import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const PeoplePerHouseType = () => {
    const { chartData } = useHouseholdChartsDataContext();

    return (
        <SimpleBars
            title={'Quantidade de pessoas no Domicílio'}
            horizontal={true}
            subtitles={
                chartData?.peoplePerHouseType?.map((item) => item.description) || []
            }
            values={chartData?.peoplePerHouseType?.map((item) => item.total  ||  0) || []}
            className='aligned-container'
        />
    );
};
